export default __webpack_public_path__ + "static/11-b7e026ff69fa5d38d1b43c9a07f6492e.jpg";